import React from 'react'
import logo from '../Assets/logo.png'
import '../App.css'
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosSearch } from "react-icons/io";
import { MdOutlineAccountCircle } from "react-icons/md";
import { IoBag } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { FaRegHeart, FaAngleDown } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useRef } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useEffect } from 'react';
import { useState } from 'react';
import { useGlobal } from '../App';
import { auth } from "../firebase/firebaseconfig";
import { db } from "../firebase/firebaseconfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { onSnapshot } from "firebase/firestore";

export default function Header() {






  // const sendEmail = async (email) => {
  //   const functions = getFunctions(app);
  //   const callSendEmail = httpsCallable(functions, "sendEmail");

  //   try {
  //     const result = await callSendEmail({
  //       to: email,
  //       subject: "Welcome To Gedar!",
  //       message: "Thanks for signing up"
  //     });

  //     console.log(result.data); // { success: true }

  //   } catch (error) {
  //     console.error(error);
  //   }
  // };



  const { products } = useGlobal();
  const user = auth.currentUser;
  const [cartCount, setCartCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const searchcontainer = useRef(null)
  const searchbar = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false);
  const [framesMenuOpen, setFramesMenuOpen] = useState(false);
  const [frameSubdomains, setFrameSubdomains] = useState([]);
  const mobileMenu = useRef(null);
  const [searchresults,setsearchresults] = useState([])

const searchopen = () => {
  if (searchcontainer.current) {
 searchcontainer.current.classList.add('active')
  }
document.body.style.overflow = 'hidden';
}
  const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

const searchclose = () => {
   if (searchcontainer.current) {
 searchcontainer.current.classList.remove('active')
  }
          document.body.style.overflow = "auto"; 

}

const toggleMenu = () => {
  setMenuOpen((prev) => {
    const next = !prev;
    document.body.style.overflow = next ? 'hidden' : 'auto';
    return next;
  });
}

const closeMenu = () => {
  setMenuOpen(false);
  setFramesMenuOpen(false);
  document.body.style.overflow = 'auto';
}

const toggleFramesMenu = () => {
  setFramesMenuOpen((prev) => !prev);
}

const encodeSubcategory = (value = "") => encodeURIComponent(value.trim());


 useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchcontainer.current && searchbar.current && !searchbar.current.contains(event.target)) {
         searchcontainer.current.classList.remove('active')
        document.body.style.overflow = "auto"; 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

// ====== CLOSE MENU WHEN CLICKING OUTSIDE ======
useEffect(() => {
  const handleClickOutside = (event) => {
    if (mobileMenu.current && !mobileMenu.current.contains(event.target)) {
      closeMenu();
    }
  };

  if (menuOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [menuOpen]);
const loadCartFromLocalStorage = () => {
  const raw = localStorage.getItem("cart");
  if (!raw) return []; // cart empty or missing
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error("Failed to parse cart from localStorage:", e);
    return [];
  }
};
// ====== LOAD CART COUNT ======

useEffect(() => {
  if (!user?.email) return;

  const q = query(collection(db, "Users"), where("User", "==", user.email));

  const unsubscribe = onSnapshot(q, (snapshot) => {
    if (!snapshot.empty) {
      const cartItems = snapshot.docs[0].data().cart || [];

      console.log("Cart snapshot:", cartItems);

      const totalCount = cartItems.reduce(
        (sum, item) => sum + (item.count || item.quantity || 1),
        0
      );

      setCartCount(totalCount);
    }
  });

  return () => unsubscribe();
}, [user]);

// ====== LOAD FRAME SUBDOMAINS ======
useEffect(() => {
  const loadFrameSubdomains = () => {
    const subdomains = [];
    products.forEach((product) => {
      if (product.category === "Frames" && product.subdomain && !subdomains.includes(product.subdomain)) {
        subdomains.push(product.subdomain);
      }
    });
    setFrameSubdomains(subdomains);
  };

  loadFrameSubdomains();
}, [products]);

useEffect(() => {
  const normalize = (text = "") => text.toLowerCase().trim();
  const normalizedQuery = normalize(searchQuery);

  if (!normalizedQuery) {
    setsearchresults([]);
    return;
  }

  const exactMatches = [];
  const partialMatches = [];

  products.forEach((product) => {
    const matches = product?.searchwords?.some(sw => {
      const word = normalize(sw);
      const words = word.split(" ");
      return words.includes(normalizedQuery); // whole word match
    });

    if (matches) {
      exactMatches.push(product);
      return;
    }

    // partial match fallback
    const partial = product?.searchwords?.some(sw =>
      normalize(sw).includes(normalizedQuery)
    );

    if (partial) {
      partialMatches.push(product);
    }
  });

  // exact first, then partial
  setsearchresults([...exactMatches, ...partialMatches]);
}, [searchQuery, products]);
useEffect(() => {
  console.log("user:", user);
}, [user]);
return (
    <>
    <div className='headercontainer'>
    <header className='d-flex align-items-center justify-content-between px-4'>
      
            <div className='searchcontainer' ref={searchcontainer}>
      
      <div className='searchbar ' ref={searchbar}>
        <h4 className='mt-3 w-100 px-4 mb-2' style={{fontWeight: '600'}}>Search</h4>
        <div className='w-100 py-3 px-4 d-flex align-items-center justify-content-between' style={{borderBottom: '1px solid rgba(0, 0, 0, 0.1)'}}>
          <input type="text" placeholder='Search For...' className='border-0 w-100' style={{fontSize: '15px'}} onChange={(e)=>setSearchQuery(e.target.value)}/>
          
          <button onClick={searchclose} style={{background: 'none', padding: '5px', marginLeft: '10px'}}><IoClose className='fs-3' style={{cursor: 'pointer', color: '#666'}}/></button>

        </div>

        <div className='searchresultcontainer'>

          <div style={{ width: '100%'}} className='d-flex flex-column'> 
            {/[a-z]/i.test(searchQuery.trim()) ? (
              searchresults.length > 0 ? (
                searchresults.map((product) => (
                  <Link key={product.id} to={`/products/${product.name?.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`} style={{textDecoration: 'none', color: 'inherit'}} onClick={searchclose}>
                    <div className='searchresult'>
                      <img src={product.imageUrl || product.image} alt={product.name} />
                      <div className='d-flex flex-column py-2' style={{flex: 1}}>
                        <h4 className='m-0' style={{fontSize: '16px', fontWeight: '500'}}>{product.name}</h4>
                        <p className='m-0 text-muted' style={{fontSize: '12px'}}>{product.category}</p>
<p
  className='m-0'
  style={{ fontSize: '14px', fontWeight: '600', color: '#007bff' }}
>
  {product.category === "Frames" ? "From " + `${product.smallframeprice}.00` : "LE " + `${product.price}.00`}
</p>                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div style={{padding: '30px', textAlign: 'center', color: '#999'}}>
                  <p>No products found</p>
                </div>
              )
            ) : (
              <div style={{padding: '30px', textAlign: 'center', color: '#999'}}>
                <p>Start typing to search...</p>
              </div>
            )}
          </div>

        </div>

      </div>
      
            </div>

            <div style={{width:'200px'}} className='d-flex align-items-center justify-content-start gap-2'>
              <button onClick={toggleMenu} title="Menu">
        <RxHamburgerMenu className='icon' />
              </button>
            </div>
        <Link to='/' onClick={scrollToTop}>
        <img src={logo} alt="Gedar Store" />
        </Link>
        <div className='d-flex align-items-center gap-2 justify-content-end' style={{width:'200px'}}>
          <button onClick={searchopen} title="Search">
        <IoIosSearch className='icon'/>
        </button>
        {user ? (
          <Link to="/profile" title="My Profile" className='hideonphone'>
            <MdOutlineAccountCircle className='icon'/> 
          </Link>
        ) : (
          <Link to="/Login" title="Sign In" className='hideonphone'>
            <MdOutlineAccountCircle className='icon'/> 
          </Link>
        )}
                  <Link to="/wishlist" title="Wishlist" className='hideonphone'>
                    <FaRegHeart className='icon'/>
                  </Link>
                                  
     <Link to="/Cart" style={{ position: 'relative' }} title="Shopping Cart">
        <IoBag className='icon'/>
        {cartCount > 0 && (
          <span style={{
            position: 'absolute',
            top: '-8px',
            right: '-8px',
            backgroundColor: '#ff6344',
            color: 'white',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: 'bold',
            lineHeight: '1'
          }}>
            {cartCount}
          </span>
        )}
                       </Link>

        </div>
    </header>
    </div>

    {/* Mobile Menu Overlay */}
    <div
      className={`mobile-menu-overlay ${menuOpen ? 'active' : ''}`}
      onClick={closeMenu}
    />

    {/* Mobile Menu */}
    <div 
      className={`mobile-menu ${menuOpen ? 'active' : ''}`}
      ref={mobileMenu}
    >
      <div className='mobile-menu-header'>
        <h5>Menu</h5>
        <button onClick={closeMenu}>
          <IoClose className='fs-3' />
        </button>
      </div>
      <nav className='mobile-menu-nav'>
        <Link to='/' onClick={closeMenu} className='mobile-menu-link'>
          Home
        </Link>
        <Link to='/category/stickers' onClick={closeMenu} className='mobile-menu-link'>
          Stickers
        </Link>
        <Link to='/category/frames' onClick={closeMenu} className='mobile-menu-link'>
          Frames
        </Link>
        <Link to='/wishlist' onClick={closeMenu} className='mobile-menu-link'>
          Wishlist
        </Link>


        <Link to='/custom' onClick={closeMenu} className='mobile-menu-link'>
          Custom Designs
        </Link>
        <Link to='/cart' onClick={closeMenu} className='mobile-menu-link'>
          My Cart ({cartCount})
        </Link>
        {user ? (
          <Link to='/profile' onClick={closeMenu} className='mobile-menu-link'>
            My Account
          </Link>
        ) : (
          <Link to='/login' onClick={closeMenu} className='mobile-menu-link'>
            Sign In
          </Link>
        )}
      </nav>
    </div>
    </>
  )
}
